module.exports = __webpack_public_path__ + "img/qu_uy.98011e6.jpg";